/**
 * DotGrid — grid de bolinhas sutil de fundo. Versão CSS-only.
 *
 * (O DotGrid original do React Bits usa GSAP + InertiaPlugin pra um efeito
 * de "shock wave" interativo no clique; o InertiaPlugin é Club Greensock
 * pago, então reescrevi como `radial-gradient` puro. Mesmo visual estático,
 * zero deps, zero peso. Se quiser a interatividade no futuro: trocar essa
 * versão pela do React Bits + comprar Club Greensock.)
 */

export interface DotGridProps {
  /** Diâmetro do ponto, px. */
  dotSize?: number;
  /** Distância entre centros dos pontos, px. */
  gap?: number;
  /** Cor do ponto. */
  baseColor?: string;
  /** Opacidade do ponto (0..1). */
  opacity?: number;
  className?: string;
  style?: React.CSSProperties;
}

export default function DotGrid({
  dotSize = 2,
  gap = 24,
  baseColor = "var(--wf-ink-4, #b3b3b3)",
  opacity = 0.45,
  className,
  style,
}: DotGridProps) {
  return (
    <div
      aria-hidden
      className={`rb-dotgrid ${className ?? ""}`}
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        backgroundImage: `radial-gradient(circle, ${baseColor} ${dotSize / 2}px, transparent ${dotSize / 2 + 0.5}px)`,
        backgroundSize: `${gap}px ${gap}px`,
        backgroundPosition: "0 0",
        opacity,
        ...style,
      }}
    />
  );
}
